function getAuditProgress(data) {
    const auditItems = data.audit.items;
    const auditItemTableColumns = [];
    auditItems.forEach((item) => {
        let columnText = '';
        let r1 = item.title;
        let r2 = item.title;
        let r3 = item.staff;
        let r4 = item.dat;

        // 退件：不用顯示流程紀錄
        if (data.status === '退件') {
            r3 = ' ';
            r4 = ' ';
        }
        // 無日期=未到的節點
        if (!item.dat) {
            r3 = ' ';
            r4 = ' ';
        }
        // 含有指定人的節點（專案經理、經辦人、專案審核人、主管），另外顯示人名（用audits第一個人）
        if (item.title === '專案經理' || item.title === '專案經辦人' || item.title === '專案審核人' || item.title === '主管' || item.title === '主管審核') {
            if (item.auditors?.length > 0) {
                r1 = item.title;
                r2 = item.auditors[0].nam;
            } else {
                r1 = ' ';
                r2 = item.title;
            }
        } else {
            r1 = ' ';
            r2 = item.title;
        }

        columnText = `${r1}\n${r2}\n\n\n\n${r3}\n${r4}`;
        const column = {
            text: columnText,
            alignment: 'center',
        };
        auditItemTableColumns.push(column);
    });

    const auditsFullWidth = 320;
    const auditsColumnWidth = auditsFullWidth / auditItems.length;
    const auditTableColumnWidths = [];
    for (let i = 0; i < auditItems.length; i += 1) {
        auditTableColumnWidths.push(auditsColumnWidth);
    }
    const auditsText = {
        table: {
            widths: auditTableColumnWidths,
            body: [auditItemTableColumns],
        },
        layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            paddingLeft: () => 0,
            paddingRight: () => 0,
            paddingTop: () => 0,
            paddingBottom: () => 0,
        },
        style: 'audits',
    };

    // 審核流程圖表
    const auditGraphBoundWidth = auditsFullWidth;
    const auditGraphStartX = auditsColumnWidth / 2;
    const auditGraphEndX = auditGraphBoundWidth - (auditsColumnWidth / 2);
    const auditGraphSectionWidth = (auditGraphEndX - auditGraphStartX) / (auditItems.length - 1);
    const auditGraphLineY = -24;
    const auditGraphDotSize = 3;
    const auditGraph = {
        canvas: [],
    };

    // 底線
    auditGraph.canvas.push(
        {
            type: 'line',
            x1: auditGraphStartX,
            y1: auditGraphLineY,
            x2: auditGraphEndX,
            y2: auditGraphLineY,
            lineWidth: 2,
            lineColor: '#cccccc',
        },
    );

    // 實線
    if (data.status !== '退件') {
        if (data.status === '完成') {
            auditGraph.canvas.push(
                {
                    type: 'line',
                    x1: auditGraphStartX,
                    y1: auditGraphLineY,
                    x2: auditGraphEndX,
                    y2: auditGraphLineY,
                    lineWidth: 2,
                    lineColor: 'black',
                },
            );
        } else {
            auditGraph.canvas.push(
                {
                    type: 'line',
                    x1: auditGraphStartX,
                    y1: auditGraphLineY,
                    x2: auditGraphStartX + auditGraphSectionWidth * (data.audit.currIndex + 1),
                    y2: auditGraphLineY,
                    lineWidth: 2,
                    lineColor: 'black',
                },
            );
        }
    }

    // 圓圈
    for (let i = 0; i < auditItems.length; i += 1) {
        let dotBorderColor = '#cccccc';
        if (data.status === '退件') {
            dotBorderColor = '#cccccc';
        } else if (data.status === '完成') {
            dotBorderColor = 'black';
        } else if (i <= data.audit.currIndex) {
            dotBorderColor = 'black';
        }
        auditGraph.canvas.push({
            type: 'ellipse',
            x: auditGraphStartX + i * auditGraphSectionWidth,
            y: auditGraphLineY,
            r1: auditGraphDotSize,
            r2: auditGraphDotSize,
            color: 'white',
            fillOpacity: 1,
            lineColor: dotBorderColor,
            lineWidth: 2,
        });
    }
    return { auditsText, auditGraph };
}

export default (data, pageSize = 'A4', pageOrientation = 'portrait') => {
    let logoImgDef = null;
    if (data.logoImg) {
        logoImgDef = {
            image: data.logoImg,
            fit: [200, 40],
            alignment: 'right',
        };
    }

    // 大標題
    const titleSection = {
        alignment: 'justify',
        columns: [
            { text: '請款單', style: 'title', margin: [2, 0, 0, 15] },
            logoImgDef,
        ],
    };

    // 請款單資訊
    let payoutItemName = '---';
    if (data.status === '待確認付款' || data.status === '完成') {
        payoutItemName = data.payoutItemName;
    }

    // 請款單資訊
    const infoSection = [
        {
            alignment: 'justify',
            columns: [
                {
                    margin: [2, 0, 0, 0],
                    layout: 'noBorders',
                    table: {
                        widths: [80, 'auto'],
                        body: [
                            ['單號', data.payoo],
                            ['狀態', data.status],
                            ['請款單日期', data.date],
                            ['申請人/日期', `${data.creator} / ${data.createDate}`],
                        ],
                    },
                    width: 200,
                },
            ],
        },
        {
            margin: [2, 0, 0, 0],
            layout: 'noBorders',
            table: {
                widths: [80, 'auto'],
                body: [
                    ['支出項目', payoutItemName],
                ],
            },
            width: 200,
        },
    ];
    // 審核流程內容
    if (data.enableDrawAuditProgress) {
        const { auditsText, auditGraph } = getAuditProgress(data);
        infoSection[0].columns.push([auditsText, auditGraph]);
    }

    // 請款類型（標題）
    const paymentInfoSectionTitle = {
        margin: [0, 15, 0, 0],
        table: {
            widths: ['*'],
            body: [
                [
                    {
                        text: data.type,
                        style: 'sectionTitle',
                    },
                ],
            ],
        },
        layout: {
            hLineWidth(i) {
                if (i === 0) return 0;
                return 2;
            },
            vLineWidth() { return 0; },
            paddingLeft() { return 0; },
        },
    };

    // 請款摘要
    const paymentInfoSectionName = {
        margin: [0, 0, 0, 0],
        table: {
            widths: [80, '*'],
            body: [
                [
                    { text: '摘要', margin: [0, 5, 0, 5] },
                    { text: data.name, margin: [0, 5, 0, 5], bold: true },
                ],
            ],
        },
        layout: {
            hLineWidth(i) {
                if (i === 0) return 0;
                return 0.1;
            },
            vLineWidth() { return 0; },
        },
    };

    // 請款專案
    let projectLabel = '';
    let projectName = '';
    if (data.type === '專案請款') {
        projectLabel = '專案';
        projectName = data.projectName;
    }
    if (data.type === '經常性費用') {
        projectLabel = '經常性費用項目';
        projectName = data.oftenProjectName;
    }
    if (data.type === '特定費請款') {
        projectLabel = '特定費項目';
        projectName = data.projectName;
    }

    const paymentInfoSectionProject = {
        margin: [0, 0, 0, 0],
        table: {
            widths: [80, '*'],
            body: [
                [
                    { text: projectLabel, margin: [0, 5, 0, 5] },
                    { text: projectName, margin: [0, 5, 0, 5] },
                ],
            ],
        },
        layout: {
            hLineWidth(i) {
                if (i === 0) return 0;
                return 0.1;
            },
            vLineWidth() { return 0; },
        },
    };

    // 請款金額
    const paymentInfoSectionAmt = {
        margin: [0, 0, 0, 0],
        table: {
            widths: ['*', 250],
            body: [
                [
                    {
                        layout: 'noBorders',
                        margin: [0, 6, 10, 6],
                        table: {
                            widths: [80, '*'],
                            body: [
                                [{ text: '預計付款方式' }, { text: data.prePayWay }],
                                [{ text: '預計付款日' }, { text: data.prePayDate }],
                            ],
                        },
                    },
                    {
                        margin: [10, 6, 10, 6],
                        fillColor: '#eeeeee',
                        text: [
                            '請款金額\n',
                            {
                                text: `${data.amt} ${data.cny}`,
                                fontSize: 17,
                                alignment: 'right',
                                bold: true,
                            },
                        ],
                    },
                ],
            ],
        },
        layout: {
            hLineWidth(i) {
                if (i === 0) return 0;
                return 0.1;
            },
            vLineWidth() { return 0; },
        },
    };

    // 付款對象-標題
    const toInfoSectionTitle = {
        margin: [0, 20, 0, 0],
        table: {
            widths: ['*'],
            body: [
                [
                    { text: '付款對象', style: 'sectionTitle' },
                ],
            ],
        },
        layout: {
            hLineWidth(i) {
                if (i === 0) return 0;
                return 2;
            },
            vLineWidth() { return 0; },
            paddingLeft() { return 0; },
        },
    };

    // 付款對象-類型＆名稱
    const toInfoSectionTypeAndName = {
        layout: 'noBorders',
        table: {
            widths: [80, '*'],
            body: [
                [data.payToType, data.payToName],
            ],
        },
    };

    // 付款對象-國際匯款
    const toInfoSectionForgin = {
        margin: [0, 10, 0, 0],
        layout: 'noBorders',
        table: {
            widths: [80, '*'],
            body: [
                ['收款人', data.receiveBankAccount],
                ['國家', data.foreginPayToCountry],
            ],
        },
    };

    // 付款對象-勞務所得類型
    const toInfoSectionServiceType = {
        layout: 'noBorders',
        table: {
            widths: [80, '*'],
            body: [
                ['勞務所得類型', data.serviceType],
            ],
        },
    };

    // 付款對象-聯絡資訊
    const toInfoSectionContact = {
        margin: [0, 10, 0, 0],
        layout: 'noBorders',
        table: {
            widths: [80, '*'],
            body: [
                ['聯絡人', data.contactName],
                ['聯絡電話', data.contactTel],
                ['聯絡E-mail', data.contactEmail],
            ],
        },
    };

    // 付款對象-收款銀行資訊
    const toInfoBankList = [];
    toInfoBankList.push([' ', ' ']);
    toInfoBankList.push(['收款銀行名稱', data.receiveBankName]);
    if (data.raw.abd !== 1) {
        toInfoBankList.push(['收款銀行代號', data.receiveBankBranchCode]);
    }
    toInfoBankList.push(['收款戶名', data.receiveBankAccount]);
    toInfoBankList.push(['收款帳號', data.receiveBankNumber]);
    const toInfoSectionBank = {
        layout: 'noBorders',
        table: {
            widths: [80, '*'],
            body: toInfoBankList,
        },
    };

    // 付款對象-工作內容
    const toInfoSectionWork = {
        margin: [0, 10, 0, 0],
        table: {
            widths: [80, '*'],
            body: [
                [
                    { text: '工作內容', margin: [0, 5, 0, 0] },
                    { text: data.serviceInfo, margin: [0, 5, 0, 0] },
                ],
            ],
        },
        layout: {
            hLineWidth(i) {
                if (i === 0) return 0.1;
                return 0;
            },
            vLineWidth() {
                return 0;
            },
            paddingLeft(i) { return i === 0 ? 0 : 2; },
        },
    };

    // 付款明細-標題
    let payInfoTitle = '付款明細';
    if (data.raw.sigN_STS === 5 && data.raw.a02_ISTEMP) {
        payInfoTitle = `${payInfoTitle}（暫存）`;
    }
    const payInfoSectionTitle = {
        margin: [0, 20, 0, 0],
        table: {
            widths: ['*'],
            body: [
                [
                    { text: payInfoTitle, style: 'sectionTitle' },
                ],
            ],
        },
        layout: {
            hLineWidth(i) {
                if (i === 0) return 0;
                return 2;
            },
            vLineWidth() {
                return 0;
            },
            paddingLeft() { return 0; },
        },
    };

    // 付款明細-代扣所得稅
    const payInfoSectionTax = [
        {
            margin: [0, 6, 10, 6],
            layout: 'noBorders',
            table: {
                widths: [80, '*'],
                body: [
                    [{ text: '代扣所得稅付款日' }, { text: data.taxPayDate }],
                    [{ text: '代扣所得稅付款帳戶' }, { text: data.taxPayBank }],
                ],
            },
        },
        {
            margin: [10, 6, 10, 6],
            fillColor: '#eeeeee',
            text: [
                '代扣所得稅金額\n',
                {
                    text: data.taxAmt !== '---' ? `${data.taxAmt} ${data.cny}` : '---',
                    fontSize: 12,
                    alignment: 'right',
                    bold: true,
                },
            ],
        },
    ];

    // 付款明細-代扣二代健保
    const payInfoSectionGen2 = [
        {
            margin: [0, 6, 10, 6],
            layout: 'noBorders',
            table: {
                widths: [80, '*'],
                body: [
                    // [{ text: '代扣二代健保' }, ''],
                    [{ text: '代扣二代健保付款日' }, { text: data.gen2PayDate }],
                    [{ text: '代扣二代健保付款帳戶' }, { text: data.gen2PayBank }],
                ],
            },
        },
        {
            margin: [10, 6, 10, 6],
            fillColor: '#eeeeee',
            text: [
                '代扣二代健保金額\n',
                {
                    text: data.gen2Amt !== '---' ? `${data.gen2Amt} ${data.cny}` : '---',
                    fontSize: 12,
                    alignment: 'right',
                    bold: true,
                },
            ],
        },
    ];

    // 付款明細-實付
    const payInfoList = [
        [{ text: '實際付款方式' }, { text: data.realPayWay }],
        [{ text: '實際付款日' }, { text: data.realPayDate }],
    ];
    if (data.realPayWay === '銀行轉帳' || data.realPayWay === '銀行提現') {
        payInfoList.push([{ text: '轉出帳戶' }, { text: data.realPayBank }]);
    }

    const payInfoSectionReal = [
        {
            margin: [0, 6, 10, 6],
            layout: 'noBorders',
            table: {
                widths: [80, '*'],
                body: payInfoList,
            },
        },
        {
            margin: [10, 6, 10, 6],
            fillColor: '#eeeeee',
            text: [
                '實付金額\n',
                {
                    text: `${data.realPayAmt} ${data.cny}`,
                    fontSize: 12,
                    alignment: 'right',
                    bold: true,
                },
            ],
        },
    ];

    if (data.status === '待確認付款' || data.status === '完成') {
        if (data.cny !== 'TWD') {
            payInfoSectionReal[1].text.push({
                text: `\n\n轉出當下匯率：${data.payCnyRat} ，約當台幣 ${data.realPayAmtTwd} 元`,
                fontSize: 8,
                alignment: 'right',
                margin: [0, 5, 0, 0],
            });
        }
    }

    // PDF 排版
    const def = {
        pageSize,
        pageOrientation,
        defaultStyle: {
            font: 'NotoSansTC',
            fontSize: 8,
            lineHeight: 0.95,
        },
        styles: {
            title: {
                fontSize: 25,
                bold: true,
            },
            sectionTitle: {
                margin: [0, 0, 0, 5],
                bold: true,
            },
            audits: {
                fontSize: 6,
                lineHeight: 0.8,
            },
        },
        content: [],
    };

    def.content.push(titleSection); // 大標題
    def.content.push(infoSection); // 請款單資訊
    def.content.push(paymentInfoSectionTitle); // 請款類型（標題）
    def.content.push(paymentInfoSectionName); // 請款摘要

    // 請款專案
    if (data.type === '專案請款'
        || data.type === '經常性費用'
        || data.type === '特定費請款'
    ) {
        def.content.push(paymentInfoSectionProject);
    }

    def.content.push(paymentInfoSectionAmt); // 請款金額 & 預計付款方式

    if (data.type === '一般請款'
        || data.type === '專案請款'
        || data.type === '經常性費用'
        || data.type === '特定費請款'
        || data.type === '國際匯款'
    ) {
        def.content.push(toInfoSectionTitle); // 付款對象-標題
        const toSection = {
            margin: [0, 10, 0, 0],
            alignment: 'justify',
            columns: [],
        };
        toSection.columns = [
            [],
            toInfoSectionBank, // 付款對象-收款銀行資訊
        ];
        if (data.type === '國際匯款') {
            def.content.push(toInfoSectionForgin);
        } else {
            toSection.columns[0].push(toInfoSectionTypeAndName); // 付款對象-類型＆名稱
            if (data.payToType === '委外勞務') {
                toSection.columns[0].push(toInfoSectionServiceType); // 付款對象-勞務所得類型
            }
            toSection.columns[0].push(toInfoSectionContact); // 付款對象-聯絡資訊)
            def.content.push(toSection);
            if (data.payToType === '委外勞務') {
                def.content.push(toInfoSectionWork); // 付款對象-工作內容
            }
        }
    }

    def.content.push(payInfoSectionTitle); // 付款明細-標題

    const payInfoTable = {
        margin: [0, 0, 0, 0],
        table: {
            widths: ['*', 250],
            body: [],
        },
        layout: {
            hLineWidth(i) {
                if (i === 0) return 0;
                return 0.1;
            },
            vLineWidth() {
                return 0;
            },
        },
    };

    if (data.payToType === '委外勞務') {
        payInfoTable.table.body.push(payInfoSectionTax); // 付款明細-代扣勞務稅
        payInfoTable.table.body.push(payInfoSectionGen2); // 付款明細-代扣二代健保
    }
    payInfoTable.table.body.push(payInfoSectionReal); // 付款明細-實付)
    def.content.push(payInfoTable);
    def.content.push({
        alignment: 'justify',
        columns: [
            {
                margin: [2, 15, 0, 0],
                layout: 'noBorders',
                table: {
                    widths: [80, '*'],
                    body: [
                        ['填寫付款明細人', data.fillPayInfoUser],
                        ['填寫付款明細日期', data.fillPayInfoDate],
                    ],
                },
            },
            {
                margin: [0, 15, 0, 0],
                layout: 'noBorders',
                table: {
                    widths: [80, '*'],
                    body: [
                        ['確認付款人', data.confirmPayInfoUser],
                        ['確認付款日期', data.confirmPayInfoDate],
                    ],
                },
            },
        ],
    });

    // 簽章區域
    if (data.enableDrawCreatorSignRect || data.enableDrawReceiverSignRect || data.enableDrawAuditSignRect) {
        const signSectionColumns = {
            margin: [0, 20, 0, 0],
            alignment: 'justify',
            columns: [' ', ' ', ' '],
        };

        // 申請人簽章欄
        if (data.enableDrawCreatorSignRect) {
            signSectionColumns.columns[0] = {
                margin: [0, 0, 15, 0],
                width: 150,
                table: {
                    widths: ['*'],
                    body: [
                        [{ text: '\n\n申請人\n簽章：', margin: [0, 5, 5, 5] }],
                    ],
                },
                layout: {
                    hLineWidth(i) {
                        return i === 1 ? 1 : 0;
                    },
                    vLineWidth() {
                        return 0;
                    },
                    paddingLeft() { return 0; },
                },
            };
        }

        // 審核人簽章欄
        if (data.enableDrawAuditSignRect) {
            signSectionColumns.columns[1] = {
                margin: [0, 0, 15, 0],
                table: {
                    widths: ['*'],
                    body: [
                        [{ text: '\n\n審核人\n簽章：', margin: [0, 5, 5, 5] }],
                    ],
                },
                layout: {
                    hLineWidth(i) {
                        return i === 1 ? 1 : 0;
                    },
                    vLineWidth() {
                        return 0;
                    },
                    paddingLeft() { return 0; },
                },
            };
        }

        // 收款人簽章欄
        if (data.enableDrawReceiverSignRect) {
            signSectionColumns.columns[2] = {
                margin: [0, 0, 0, 0],
                width: 150,
                table: {
                    widths: ['*'],
                    body: [
                        [{ text: '\n\n收款人\n簽章：', margin: [0, 5, 5, 5] }],
                    ],
                },
                layout: {
                    hLineWidth(i) {
                        return i === 1 ? 1 : 0;
                    },
                    vLineWidth() {
                        return 0;
                    },
                    paddingLeft() { return 0; },
                },
            };
        }

        def.content.push(signSectionColumns);
    }

    return def;
};
